import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cards-grid-section__container" }
const _hoisted_2 = { class: "container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionSpacerClouds = _resolveComponent("SectionSpacerClouds")!
  const _component_SectionSpacerBar = _resolveComponent("SectionSpacerBar")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["cards-grid-section", {'clouds-bottom': _ctx.spacer === 'clouds' && _ctx.spacerCloudsPlacement === 'bottom'}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["cards-grid-section__container__row row g-4 g-xl-5", `cols-${_ctx.columns}`])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ])
    ]),
    (_ctx.spacer === 'clouds')
      ? (_openBlock(), _createBlock(_component_SectionSpacerClouds, {
          key: 0,
          placement: _ctx.spacerCloudsPlacement
        }, null, 8, ["placement"]))
      : _createCommentVNode("", true),
    (_ctx.spacer === 'bar')
      ? (_openBlock(), _createBlock(_component_SectionSpacerBar, {
          key: 1,
          align: _ctx.spacerBarAlign
        }, null, 8, ["align"]))
      : _createCommentVNode("", true)
  ], 2))
}